module.exports = __webpack_public_path__ + "resources/img/logo_partner_commerce_bdtong.9cb919761e3539b80e6f5f344cfeb7aa.png";